// import React, {createContext, useContext, useState, useCallback, useRef} from 'react';
// import {Dialog} from 'primereact/dialog';
// import { Button } from 'primereact/button';

// const TimeoutContext = createContext();

// export const TimeoutProvider = ({children}) => {
//     const [visible, setVisible] = useState(false);
//     const [resolver, setResolver] = useState(null);
//     const controllerRef = useRef(null);

//     const showTimeout = useCallback((controller) => {
//         controllerRef.current = controller;
//         setVisible(true);
//         return new Promise((resolve) => {
//             setResolver(()=>resolve)
//         })
//     }, []);

//     const handleContinue = () => {
//         setVisible(false);
//         resolver('continue');
//     }

//     const handleCancel = () => {
//         controllerRef.current?.abort();
//         setVisible(false);
//         resolver('cancel');
//     }

//     return (
//         <TimeoutContext.Provider value={{showTimeout}}>
//             {children}
//             <Dialog
//                     header="Long Response Time"
//                     visible={visible}
//                       closable={false}
//                       footer={
//                         <>
//                           <div style={{ display: "flex", justifyContent: "center", gap: '20px'}}>
//                             <Button label="Continue" icon="pi pi-clock" onClick={handleContinue} className="custom-icon-spacing" />
//                             <Button label="Cancel" icon="pi pi-times" onClick={handleCancel} className="p-button-danger custom-icon-spacing" />
//                           </div>
//                         </>
//                       }
//                   >
//                     <p>This taking longer than expected. Do you wan to continue waiting or cancel?</p>
//                   </Dialog>
//         </TimeoutContext.Provider>
//     )
// }

// export const useTimeoutContext = () => useContext(TimeoutContext);

import React, {createContext, useContext, useState, useCallback, useRef} from 'react';
import {Dialog} from 'primereact/dialog';
import { Button } from 'primereact/button';

const TimeoutContext = createContext();

export const TimeoutProvider = ({children}) => {
    const [visible, setVisible] = useState(false);
    const resolveRef = useRef(null);
    const controllerRef = useRef(null);

    const showTimeout = useCallback((controller) => {
        controllerRef.current = controller;
        setVisible(true);
        return new Promise((resolve) => {
          resolveRef.current=resolve;
        })
    }, []);

    const setResolvedExternally=()=>{
      if(resolveRef.current) {
        resolveRef.current('auto');
        resolveRef.current = null;
        setVisible(false);
      }
    }

    const handleContinue = () => {
      if(resolveRef.current) {
        resolveRef.current('continue');
        resolveRef.current = null;
        setVisible(false)
      }
    }

    const handleCancel = () => {
      controllerRef.current?.abort();
      if(resolveRef.current) {
        resolveRef.current('cancel');
        resolveRef.current=null;
        setVisible(false);
      }
    }

    return (
        <TimeoutContext.Provider value={{showTimeout, setResolvedExternally}}>
            {children}
            <Dialog
                    header="Long Response Time"
                    visible={visible}
                      closable={false}
                      footer={
                        <>
                          <div style={{ display: "flex", justifyContent: "center", gap: '20px'}}>
                            <Button label="Continue" icon="pi pi-clock" onClick={handleContinue} className="custom-icon-spacing" />
                            <Button label="Cancel" icon="pi pi-times" onClick={handleCancel} className="p-button-danger custom-icon-spacing" />
                          </div>
                        </>
                      }
                  >
                    <p>This taking longer than expected. Do you want to continue waiting or cancel?</p>
                  </Dialog>
        </TimeoutContext.Provider>
    )
}

export const useTimeoutContext = () => useContext(TimeoutContext);